module.exports = __webpack_public_path__ + "img/logo-menu-branco.cfdcdbe7.svg";